import React, { useEffect,  } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ScreenHeader } from "react-library";
import { Routes } from "../../routes";
import DiseaseSpeedoMeters from "./component/DiseaseSpeedoMeters";
import "./disease-sensors.css";
import { CropStageDetails } from "../cropStageDetails";
import { t } from "../../services/locale.service";

const DiseaseSensorsScreen: React.FC = () => {
  const { plotId } = useParams();
  const navigate = useNavigate();


  const headerTitle = t("Disease_Sensors");

  const viewCropStageDetails = (e: Event) => {
    const event = e as Event & { detail: CropStageDetails };
    navigate(Routes.cropStageDetails.replace(":plotId", plotId!), { state: { cropStageDetails: event.detail } });
  };

     
  const handleBack = () => {
    try {
      window.history.back();
    } catch (error) {
      console.log(error);      
    }
  };

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    window.addEventListener(
      "open-cropstage-details",
      viewCropStageDetails
    );
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
      window.removeEventListener("open-cropstage-details", viewCropStageDetails);
    };
  }, []);

  return (
    <div className="container">
      <ScreenHeader screenName={headerTitle} />
      <DiseaseSpeedoMeters plotId={plotId!} />

      {/* {hasInsights && (
          <SpeedoMetersContainer
            plotId={plotId!}
            farmData={farmData}
            speedoMeterFor="insight"
          />
        )} */}
    </div>
  );
};

export default DiseaseSensorsScreen;
 
 
export const Insights = ["deltaT", "VPD"];
